import { motion } from "framer-motion";

export const scoreColor = (v) => (v < 35 ? "#dc2626" : v < 60 ? "#d97706" : "#16a34a");

export default function Gauge({ value = 0, size = 140, stroke = 12, label, color, track = "#e2e8f0", textColor }) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const pct = Math.max(0, Math.min(100, value)) / 100;

  return (
    <div className="gauge" style={{ width: size, height: size }}>
      <svg width={size} height={size}>
        <defs>
          <linearGradient id="scoreGradient" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#ffb35c" />
            <stop offset="100%" stopColor="#f26b1d" />
          </linearGradient>
        </defs>
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={track} strokeWidth={stroke} />
        <motion.circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke={color || scoreColor(value)}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={c}
          initial={{ strokeDashoffset: c }}
          animate={{ strokeDashoffset: c * (1 - pct) }}
          transition={{ duration: 1.1, ease: "easeOut" }}
        />
      </svg>
      <div className="gauge-center">
        <div className="gauge-value" style={{ fontSize: size * 0.26, color: textColor }}>{Math.round(value)}</div>
        {label && <div className="gauge-label">{label}</div>}
      </div>
    </div>
  );
}
